import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { Municipality, Nation, Province, Region } from '../model/patient.model';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationsService {

  constructor(private http: HttpService) { }

  getPatientClasses(): Observable<string[]> {
    return this.http.get(environment.endpoints.configuration + `/patientClasses`) as Observable<string[]>;
  }

  getEthnicities(): Observable<string[]> {
    return this.http.get(environment.endpoints.configuration + `/ethnicities`) as Observable<string[]>;
  }

  getSexualities(): Observable<string[]> {
    return this.http.get(environment.endpoints.configuration + `/sexualities`) as Observable<string[]>;
  }

  getNations(): Observable<Nation[]> {
    return this.http.get(environment.endpoints.configuration + `/nations`) as Observable<Nation[]>;
  }

  getRegions(nationId: string): Observable<Region[]> {
    return this.http.get(environment.endpoints.configuration + `/nations/${nationId}`) as Observable<Region[]>;
  }

  getProvinces(regionId: string): Observable<Province[]> {
    return this.http.get(environment.endpoints.configuration + `/regions/${regionId}`) as Observable<Province[]>;
  }

  getMunicipalities(provinceId: string): Observable<Municipality[]> {
    return this.http.get(environment.endpoints.configuration + `/provinces/${provinceId}`) as Observable<Municipality[]>;
  }
}
